/**
 * Cell 패키지가 생기기 이전에 사용하던 Icon 컴포넌트입니다.
 *
 * 이 컴포넌트는 deprecated 되어야 하며, cell의 아이콘이 필요할 때에는 cell-icon 패키지를 사용해주세요.
 *
 * cell에 없는 새 Icon을 추가할 때에는 src/components/atomic/atoms/CheetahIcon에 추가해주세요.
 */
export enum IconPack {
  GENERAL_ACTION_ALERT_REJECTRION = 'GENERAL_ACTION_ALERT_REJECTRION',
  GENERAL_ACTION_ARROW_DOWN = 'GENERAL_ACTION_ARROW_DOWN',
  GENERAL_ACTION_ARROW_RIGHT = 'GENERAL_ACTION_ARROW_RIGHT',
  GENERAL_ACTION_ARROW_UP = 'GENERAL_ACTION_ARROW_UP',
  GENERAL_ACTION_ARROW_UPPERRIGHT = 'GENERAL_ACTION_ARROW_UPPERRIGHT',
  GENERAL_ACTION_ARROWSMALL_DOWN = 'GENERAL_ACTION_ARROWSMALL_DOWN',
  GENERAL_ACTION_ARROWSMALL_LEFT = 'GENERAL_ACTION_ARROWSMALL_LEFT',
  GENERAL_ACTION_ARROWSMALL_RIGHT = 'GENERAL_ACTION_ARROWSMALL_RIGHT',
  GENERAL_ACTION_ARROWSMALL_UP = 'GENERAL_ACTION_ARROWSMALL_UP',
  GENERAL_ACTION_BACK_BLACK = 'GENERAL_ACTION_BACK_BLACK',
  GENERAL_ACTION_BACK_WHITE = 'GENERAL_ACTION_BACK_WHITE',
  GENERAL_ACTION_CHECKBOX_OFF = 'GENERAL_ACTION_CHECKBOX_OFF',
  GENERAL_ACTION_CHECKBOX_ON = 'GENERAL_ACTION_CHECKBOX_ON',
  GENERAL_ACTION_COMMENT = 'GENERAL_ACTION_COMMENT',
  GENERAL_ACTION_DELETE = 'GENERAL_ACTION_DELETE',
  GENERAL_ACTION_EXIT_BLACK = 'GENERAL_ACTION_EXIT_BLACK',
  GENERAL_ACTION_EXIT_GRAY = 'GENERAL_ACTION_EXIT_GRAY',
  GENERAL_ACTION_EXIT_ORANGE = 'GENERAL_ACTION_EXIT_ORANGE',
  GENERAL_ACTION_EXIT_WHITE = 'GENERAL_ACTION_EXIT_WHITE',
  GENERAL_ACTION_MORE_BLACK = 'GENERAL_ACTION_MORE_BLACK',
  GENERAL_ACTION_MORE_VERTICAL = 'GENERAL_ACTION_MORE_VERTICAL',
  GENERAL_ACTION_MORE_WHITE = 'GENERAL_ACTION_MORE_WHITE',
  GENERAL_ACTION_RADIO_OFF = 'GENERAL_ACTION_RADIO_OFF',
  GENERAL_ACTION_RADIO_ON = 'GENERAL_ACTION_RADIO_ON',
  GENERAL_ACTION_RETRY = 'GENERAL_ACTION_RETRY',
  GENERAL_ACTION_SETTING_BLACK = 'GENERAL_ACTION_SETTING_BLACK',
  GENERAL_ACTION_SETTING_WHITE = 'GENERAL_ACTION_SETTING_WHITE',
  GENERAL_ACTION_SHAREAOS_BLACK = 'GENERAL_ACTION_SHAREAOS_BLACK',
  GENERAL_ACTION_SHAREAOS_WHITE = 'GENERAL_ACTION_SHAREAOS_WHITE',
  GENERAL_ACTION_SHAREIOS_BLACK = 'GENERAL_ACTION_SHAREIOS_BLACK',
  GENERAL_ACTION_SHAREIOS_WHITE = 'GENERAL_ACTION_SHAREIOS_WHITE',
  GENERAL_ACTION_SLIDER = 'GENERAL_ACTION_SLIDER',
  GENERAL_CERTIFICATION_CCTV = 'GENERAL_CERTIFICATION_CCTV',
  GENERAL_CERTIFICATION_CCTV_LABEL = 'GENERAL_CERTIFICATION_CCTV_LABEL',
  GENERAL_CERTIFICATION_CHECK_ORANGE = 'GENERAL_CERTIFICATION_CHECK_ORANGE',
  GENERAL_CERTIFICATION_CHECK_SUCCESS = 'GENERAL_CERTIFICATION_CHECK_SUCCESS',
  GENERAL_CERTIFICATION_DOCTOR = 'GENERAL_CERTIFICATION_DOCTOR',
  GENERAL_CERTIFICATION_DOCTOR_LATTE = 'GENERAL_CERTIFICATION_DOCTOR_LATTE',
  GENERAL_CERTIFICATION_ERROR = 'GENERAL_CERTIFICATION_ERROR',
  GENERAL_CERTIFICATION_FOLLOWUPCOST = 'GENERAL_CERTIFICATION_FOLLOWUPCOST',
  GENERAL_CERTIFICATION_FOLLOWUPCOST_LABEL = 'GENERAL_CERTIFICATION_FOLLOWUPCOST_LABEL',
  GENERAL_CERTIFICATION_INFO = 'GENERAL_CERTIFICATION_INFO',
  GENERAL_CERTIFICATION_PURCHASE = 'GENERAL_CERTIFICATION_PURCHASE',
  GENERAL_CERTIFICATION_PURCHASE_LABEL = 'GENERAL_CERTIFICATION_PURCHASE_LABEL',
  GENERAL_CERTIFICATION_PURCHASE_LABEL_JP = 'GENERAL_CERTIFICATION_PURCHASE_LABEL_JP',
  GENERAL_CERTIFICATION_VAT = 'GENERAL_CERTIFICATION_VAT',
  GENERAL_CERTIFICATION_VAT_LABEL = 'GENERAL_CERTIFICATION_VAT_LABEL',
  GENERAL_FEATURE_COMMENT = 'GENERAL_FEATURE_COMMENT',
  GENERAL_FEATURE_EVALUATION_FULL = 'GENERAL_FEATURE_EVALUATION_FULL',
  GENERAL_FEATURE_EVALUATION_HALF = 'GENERAL_FEATURE_EVALUATION_HALF',
  GENERAL_FEATURE_EVALUATION_NONE = 'GENERAL_FEATURE_EVALUATION_NONE',
  GENERAL_FEATURE_LIKE_BLACK = 'GENERAL_FEATURE_LIKE_BLACK',
  GENERAL_FEATURE_LIKE_OFF = 'GENERAL_FEATURE_LIKE_OFF',
  GENERAL_FEATURE_LIKE_ON = 'GENERAL_FEATURE_LIKE_ON',
  GENERAL_FEATURE_LIKE_WHITE = 'GENERAL_FEATURE_LIKE_WHITE',
  GENERAL_FEATURE_SAVE_BLACK = 'GENERAL_FEATURE_SAVE_BLACK',
  GENERAL_FEATURE_SAVE_OFF = 'GENERAL_FEATURE_SAVE_OFF',
  GENERAL_FEATURE_SAVE_ON = 'GENERAL_FEATURE_SAVE_ON',
  GENERAL_FEATURE_SAVE_WHITE = 'GENERAL_FEATURE_SAVE_WHITE',
  GENERAL_FEATURE_THUMBSDOWN_OFF = 'GENERAL_FEATURE_THUMBSDOWN_OFF',
  GENERAL_FEATURE_THUMBSDOWN_ON = 'GENERAL_FEATURE_THUMBSDOWN_ON',
  GENERAL_FEATURE_THUMBSUP_OFF = 'GENERAL_FEATURE_THUMBSUP_OFF',
  GENERAL_FEATURE_THUMBSUP_ON = 'GENERAL_FEATURE_THUMBSUP_ON',
  GENERAL_INFORMATION_CAMERA = 'GENERAL_INFORMATION_CAMERA',
  GENERAL_INFORMATION_DOCTOR = 'GENERAL_INFORMATION_DOCTOR',
  GENERAL_INFORMATION_HASHTAG = 'GENERAL_INFORMATION_HASHTAG',
  GENERAL_INFORMATION_HOSPITAL = 'GENERAL_INFORMATION_HOSPITAL',
  GENERAL_INFORMATION_LOCATION = 'GENERAL_INFORMATION_LOCATION',
  GENERAL_INFORMATION_MESSAGE = 'GENERAL_INFORMATION_MESSAGE',
  GENERAL_INFORMATION_OPERATION = 'GENERAL_INFORMATION_OPERATION',
  GENERAL_INFORMATION_PARTS = 'GENERAL_INFORMATION_PARTS',
  GENERAL_INFORMATION_PHOTO = 'GENERAL_INFORMATION_PHOTO',
  GENERAL_INFORMATION_RECENTSEARCH = 'GENERAL_INFORMATION_RECENTSEARCH',
  GENERAL_INFORMATION_REPORT = 'GENERAL_INFORMATION_REPORT',
  GENERAL_INFORMATION_SUBWAY = 'GENERAL_INFORMATION_SUBWAY',
  GENERAL_INFORMATION_TOOLTIP = 'GENERAL_INFORMATION_TOOLTIP',
  GNUN_SYMBOL = 'GNUN_SYMBOL',
  HEADER_ALERT_BLACK = 'HEADER_ALERT_BLACK',
  HEADER_ALERT_WHITE = 'HEADER_ALERT_WHITE',
  HEADER_LOCATION_WHITE = 'HEADER_LOCATION_WHITE',
  HEADER_MYPAGE_BLACK = 'HEADER_MYPAGE_BLACK',
  HEADER_MYPAGE_WHITE = 'HEADER_MYPAGE_WHITE',
  HEADER_SEARCH_BLACK = 'HEADER_SEARCH_BLACK',
  HEADER_SEARCH_WHITE = 'HEADER_SEARCH_WHITE',
  HEADER_WRITE = 'HEADER_WRITE',
  HEADER_WRITE_WHITE = 'HEADER_WRITE_WHITE',
  HOSPITALINFO_AFTERCARE = 'HOSPITALINFO_AFTERCARE',
  HOSPITALINFO_ANESTHESIOLOGIST = 'HOSPITALINFO_ANESTHESIOLOGIST',
  HOSPITALINFO_CCTV = 'HOSPITALINFO_CCTV',
  HOSPITALINFO_COOPERATION = 'HOSPITALINFO_COOPERATION',
  HOSPITALINFO_EMERGENCY = 'HOSPITALINFO_EMERGENCY',
  HOSPITALINFO_INPATIENTROOM = 'HOSPITALINFO_INPATIENTROOM',
  HOSPITALINFO_LADYDOCTOR = 'HOSPITALINFO_LADYDOCTOR',
  HOSPITALINFO_LODGING = 'HOSPITALINFO_LODGING',
  HOSPITALINFO_NIGHT = 'HOSPITALINFO_NIGHT',
  HOSPITALINFO_PETIT = 'HOSPITALINFO_PETIT',
  HOSPITALINFO_REALNAME = 'HOSPITALINFO_REALNAME',
  HOSPITALINFO_RECOVERYROOM = 'HOSPITALINFO_RECOVERYROOM',
  LOADER_DOTS = 'LOADER_DOTS',
  MYPAGE_ACTIVITY = 'MYPAGE_ACTIVITY',
  MYPAGE_CASH = 'MYPAGE_CASH',
  MYPAGE_CONSULTATION = 'MYPAGE_CONSULTATION',
  MYPAGE_DICTIONARY = 'MYPAGE_DICTIONARY',
  MYPAGE_DOCTOR = 'MYPAGE_DOCTOR',
  MYPAGE_ESTIMATEBOX = 'MYPAGE_ESTIMATEBOX',
  MYPAGE_EXHIBITION = 'MYPAGE_EXHIBITION',
  MYPAGE_GNTV = 'MYPAGE_GNTV',
  MYPAGE_HOSPITAL = 'MYPAGE_HOSPITAL',
  MYPAGE_LIKE = 'MYPAGE_LIKE',
  MYPAGE_LIVE = 'MYPAGE_LIVE',
  MYPAGE_LIVELIST = 'MYPAGE_LIVELIST',
  MYPAGE_PERSONALIZATION = 'MYPAGE_PERSONALIZATION',
  NAVBAR_CATEGORY_OFF = 'NAVBAR_CATEGORY_OFF',
  NAVBAR_CATEGORY_ON = 'NAVBAR_CATEGORY_ON',
  NAVBAR_CHATTING_OFF = 'NAVBAR_CHATTING_OFF',
  NAVBAR_CHATTING_ON = 'NAVBAR_CHATTING_ON',
  NAVBAR_EVENT_OFF = 'NAVBAR_EVENT_OFF',
  NAVBAR_EVENT_ON = 'NAVBAR_EVENT_ON',
  NAVBAR_HOME_OFF = 'NAVBAR_HOME_OFF',
  NAVBAR_HOME_ON = 'NAVBAR_HOME_ON',
  NAVBAR_HOSPITAL_OFF = 'NAVBAR_HOSPITAL_OFF',
  NAVBAR_HOSPITAL_ON = 'NAVBAR_HOSPITAL_ON',
  NAVBAR_REVIEW_OFF = 'NAVBAR_REVIEW_OFF',
  NAVBAR_REVIEW_ON = 'NAVBAR_REVIEW_ON',
  PARTS_ACNE_OFF = 'PARTS_ACNE_OFF',
  PARTS_ACNE_ON = 'PARTS_ACNE_ON',
  PARTS_ALL_OFF = 'PARTS_ALL_OFF',
  PARTS_ALL_ON = 'PARTS_ALL_ON',
  PARTS_BEAUTY_OFF = 'PARTS_BEAUTY_OFF',
  PARTS_BEAUTY_ON = 'PARTS_BEAUTY_ON',
  PARTS_BODYLINE_OFF = 'PARTS_BODYLINE_OFF',
  PARTS_BODYLINE_ON = 'PARTS_BODYLINE_ON',
  PARTS_BOTOX_OFF = 'PARTS_BOTOX_OFF',
  PARTS_BOTOX_ON = 'PARTS_BOTOX_ON',
  PARTS_BREAST_OFF = 'PARTS_BREAST_OFF',
  PARTS_BREAST_ON = 'PARTS_BREAST_ON',
  PARTS_CHIN_OFF = 'PARTS_CHIN_OFF',
  PARTS_CHIN_ON = 'PARTS_CHIN_ON',
  PARTS_EAR_OFF = 'PARTS_EAR_OFF',
  PARTS_EAR_ON = 'PARTS_EAR_ON',
  PARTS_ETC_OFF = 'PARTS_ETC_OFF',
  PARTS_ETC_ON = 'PARTS_ETC_ON',
  PARTS_EYE_OFF = 'PARTS_EYE_OFF',
  PARTS_EYE_ON = 'PARTS_EYE_ON',
  PARTS_FACELINE_OFF = 'PARTS_FACELINE_OFF',
  PARTS_FACELINE_ON = 'PARTS_FACELINE_ON',
  PARTS_FILLER_OFF = 'PARTS_FILLER_OFF',
  PARTS_FILLER_ON = 'PARTS_FILLER_ON',
  PARTS_FOREHEAD_OFF = 'PARTS_FOREHEAD_OFF',
  PARTS_FOREHEAD_ON = 'PARTS_FOREHEAD_ON',
  PARTS_HAIR_OFF = 'PARTS_HAIR_OFF',
  PARTS_HAIR_ON = 'PARTS_HAIR_ON',
  PARTS_LIFTING_OFF = 'PARTS_LIFTING_OFF',
  PARTS_LIFTING_ON = 'PARTS_LIFTING_ON',
  PARTS_LIP_OFF = 'PARTS_LIP_OFF',
  PARTS_LIP_ON = 'PARTS_LIP_ON',
  PARTS_MAN_OFF = 'PARTS_MAN_OFF',
  PARTS_MAN_ON = 'PARTS_MAN_ON',
  PARTS_NONE_OFF = 'PARTS_NONE_OFF',
  PARTS_NONE_ON = 'PARTS_NONE_ON',
  PARTS_NOSE_OFF = 'PARTS_NOSE_OFF',
  PARTS_NOSE_ON = 'PARTS_NOSE_ON',
  PARTS_ORIENTAL_OFF = 'PARTS_ORIENTAL_OFF',
  PARTS_ORIENTAL_ON = 'PARTS_ORIENTAL_ON',
  PARTS_PETIT_OFF = 'PARTS_PETIT_OFF',
  PARTS_PETIT_ON = 'PARTS_PETIT_ON',
  PARTS_TEETH_OFF = 'PARTS_TEETH_OFF',
  PARTS_TEETH_ON = 'PARTS_TEETH_ON',
  PARTS_TEETHANDOPTICAL_OFF = 'PARTS_TEETHANDOPTICAL_OFF',
  PARTS_TEETHANDOPTICAL_ON = 'PARTS_TEETHANDOPTICAL_ON',
  PARTS_TRANSPLANT_OFF = 'PARTS_TRANSPLANT_OFF',
  PARTS_TRANSPLANT_ON = 'PARTS_TRANSPLANT_ON',
  PARTS_WAXING_OFF = 'PARTS_WAXING_OFF',
  PARTS_WAXING_ON = 'PARTS_WAXING_ON',
  PARTS_WOMAN_OFF = 'PARTS_WOMAN_OFF',
  PARTS_WOMAN_ON = 'PARTS_WOMAN_ON',
  PARTS_YZONE_OFF = 'PARTS_YZONE_OFF',
  PARTS_YZONE_ON = 'PARTS_YZONE_ON',
}
